import { Component, OnInit } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Empty_Suggest_Interface, Suggest_Interface } from 'src/app/Interface/Suggest_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { SuggestService } from 'src/app/Service/Suggest/Suggest.service';

@Component({
  selector: 'app-SuggestList',
  templateUrl: './SuggestList.component.html',
  styleUrls: ['./SuggestList.component.scss']
})
export class SuggestListComponent implements OnInit {
  Filter_title:string=""
  page:number=0;
  Procssing:boolean=false

  constructor(
    private Suggest_Service:SuggestService,
    private Alertify_Service:AlertifyService,
    private Nav_Service:NavService,
    private modalService: BsModalService
  ) { }


  DataList_Suggest:Array<Suggest_Interface>=[]


  ngOnInit() {
    this.Nav_Service.CheckValidPage(2181).subscribe(
      data=>{
        this.ReadData_Suggest()
      }
      ,error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )


  }

  ReadData_Suggest(){
    this.Procssing=true
    this.Suggest_Service.GetRecord().subscribe(
      data=>{
        this.DataList_Suggest=data
        this.Procssing=false
      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  order:string=''
  orderreverse :boolean=true
  ChangeOrder(item:string)
  {
    this.order=item
    this.orderreverse=!this.orderreverse
  }


  //#region  Form

  Data_Seleted_Suggest:Suggest_Interface=Empty_Suggest_Interface()
  Selected_Record_Switcher: string = 'List'
  Set_List_Suggest_View() {
    this.Selected_Record_Switcher = 'List'
    this.ReadData_Suggest()
  }

  Set_Form_Suggest_View(item:Suggest_Interface,Switcher:string) {
    this.Data_Seleted_Suggest = item
    this.Selected_Record_Switcher = Switcher
  }

  Set_Form_Suggest_View_Add() {
    this.Data_Seleted_Suggest = Empty_Suggest_Interface()
    this.Selected_Record_Switcher = 'Form'
  }

  //#endregion

}
